import { Routes, Route } from 'react-router-dom';
import AllGames from './pages/AllGames';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import Profile from './pages/profile/Profile';
import RequireAuth from './components/RequireAuth';
import RedirectIfAuth from './components/RedirectIfAuth';
import Home from './pages/Home';
import Ligningsmester_1 from './components/games/ligningsmester/ligningsmester_1/Ligningsmester_1';
import Ligningsmester_2 from './components/games/ligningsmester/ligningsmester_2/Ligningsmester_2';
import Ligningsmester from './components/games/ligningsmester/Ligningsmester';
import Register from './pages/Register';
import { UserProvider } from "./contexts/UserContext";
import ScrollToTop from './components/ScrollToTop.js';
import { useEffect, useState } from 'react';
import LoadingScreen from './components/LoadingScreen';

function App() {
  const [isBackendAwake, setIsBackendAwake] = useState(false);

  useEffect(() => {
    fetch("https://matly-backend.onrender.com/api/ping")
      .then(() => setIsBackendAwake(true))
      .catch(() => {
        console.error("Backend is not awake");
      });
      }, []);

  if (!isBackendAwake) {
    return <LoadingScreen />;
  }
    
  return (
    <UserProvider>
      <div className="">
        <ScrollToTop />
        <Routes>
          <Route element={<RedirectIfAuth />}>
            <Route path="/" element={<LoginPage />} />
            <Route path="/register" element={<Register />} />
          </Route>
          <Route element={<Layout />}>
            <Route element={<RequireAuth />}>
              <Route path="/drills" element={<AllGames />} />
              <Route path="/drills/ligningsmester_1" element={<Ligningsmester_1 />} />
              <Route path="/drills/ligningsmester_2" element={<Ligningsmester_2 />} />
              <Route path="/drills/ligningsmester" element={<Ligningsmester />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/home" element={<Home />} />
            </Route>
          </Route>
        </Routes>
      </div>
    </UserProvider>
  );
}

export default App;